<template>
  <div class="ap-input" :class="classes">
    <span class="ap-input__label">{{ label }}</span>
    <div class="ap-input__input">
      <input
        :id="id"
        :type="type"
        :name="name"
        :required="required"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :value="value"
        class="ba-w-full ba-text-xl ba-relative ba-bg-transparent"
        @focus="onFocusIn"
        @blur="onFocusOut"
        @input="onInput"
      />
      <i
        @click="onIconClick"
        class="ba-absolute ba-right-0 ba-text-md"
        :class="[icon, iconClickable ? 'ba-cursor-pointer' : '']"
        :style="disabled ? { opacity: 0.38 } : null"
      ></i>
    </div>
    <div
      v-if="errorMessageText"
      class="error ba-absolute ba-left-0 ba-bottom-0 ba-text-xs ba-leading-none"
    >
      {{ errorMessageText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "vis-form-input",
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconClickable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: null
    },
    customRequired: {
      type: Boolean,
      default: false
    },
    customRequiredMessage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      focus: false,
      isValid: true
    };
  },
  computed: {
    errorMessageText() {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      if (!this.isValid) {
        if (this.customRequired) {
          return this.customRequiredMessage;
        }
      }

      return "";
    },
    classes() {
      return [
        { "ap-input--active": this.isActive },
        { "ap-input--focused": this.focus }
      ];
    },
    isActive() {
      return this.focus || !!this.value;
    }
  },
  methods: {
    onInput(event) {
      const { value } = event.target;
      this.validate(value);
      this.$emit("input", value);
    },
    onFocusIn() {
      this.focus = true;
    },
    onFocusOut() {
      this.focus = false;
      this.validate(this.value);
    },
    onIconClick() {
      if (this.iconClickable) {
        this.$emit("icon-click");
      }
    },
    validate(value) {
      if (this.customRequired) {
        this.isValid = !!value;
        return;
      }

      this.isValid = true;
    }
  }
};
</script>
